// The Gestão page's tabs. Each keeps its own address, so links and the back button still work.
export const MANAGEMENT_SECTIONS = [
  { path: "/connections", labelKey: "mainDrawer.listItems.connections" },
  { path: "/queues", labelKey: "mainDrawer.listItems.queues" },
  { path: "/users", labelKey: "mainDrawer.listItems.users" },
  { path: "/queue-integration", labelKey: "mainDrawer.listItems.queueIntegration", planFlag: "useAutomation" },
];

export const MANAGEMENT_PATHS = MANAGEMENT_SECTIONS.map(({ path }) => path);

// The routes also accept "/users/" and "/Users", so tabs and pages compare against this form.
export const canonicalPath = (pathname = "") => pathname.replace(/\/+$/, "").toLowerCase() || "/";
